module.exports = __webpack_public_path__ + "media/img/private-venue/wework-ffd451c49fe4aed6d4c80d5643d8ac13.png";